"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_final_form_1 = require("react-final-form");
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var formatters_1 = require("utils/formatters");
var OnChange_1 = __importDefault(require("./OnChange"));
var FieldText = function (_a) {
    var _b;
    var showLabel = _a.showLabel, props = __rest(_a, ["showLabel"]);
    var submitting = (0, react_final_form_1.useFormState)({ subscription: { submitting: true } }).submitting;
    var fieldDefaultLabel = (_b = props.placeholder) !== null && _b !== void 0 ? _b : (0, formatters_1.camelToProper)(props.name);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, __assign({ component: TextField_1.default, placeholder: fieldDefaultLabel, label: showLabel ? fieldDefaultLabel : undefined, disabled: submitting }, props)), props.onChange && (0, jsx_runtime_1.jsx)(OnChange_1.default, { onChange: props.onChange, name: props.name })] }));
};
exports.default = FieldText;
